<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-filters">
        <div class="filter-list">
          <div class="filter-item">
            <span class="title">Name:</span>
            <el-input class="content" placeholder="Search by name" v-model="filter.name" size="small" clearable @change="changeFilter"></el-input>
          </div>
          <div class="filter-item">
            <span class="title">Email:</span>
            <el-input class="content" placeholder="Search by email" v-model="filter.email" size="small" clearable @change="changeFilter"></el-input>
          </div>
          <div class="filter-item">
            <span class="title">Brand Status: </span>
            <el-select class="content" size="small" v-model="filter.brandStatus" placeholder="Search by brand status" @change="changeFilter">
              <el-option key="0" label="All" value=""></el-option>
              <el-option key="1" label="Active" value="active"></el-option>
              <el-option key="2" label="Pending" value="pending"></el-option>
            </el-select>
          </div>
          <!-- <div class="filter-item">
            <span class="title">Role: </span>
            <el-select class="content" size="small" v-model="filter.role" placeholder="Search by role" @change="changeFilter">
              <el-option key="0" label="All" value=""></el-option>
              <el-option v-for="item in roles" :key="item._id" :label="item.name" :value="item._id"></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="filter-actions">
          <el-button class="el-btn-blue" size="small" @click="changeFilter">Search</el-button>
          <el-button class="action-reset" size="small" @click="resetFilter">Reset</el-button>
        </div>
      </div>
      <div class="main-actions">
        <el-button class="el-btn-blue" size="small" icon="el-icon-plus" @click="newUser()">New Customer</el-button>
      </div>
      <div class="main-table">
        <el-table :data="users" v-loading="flagLoading.getUsers" border>
          <el-table-column type="index" label="#" :index="generateIndex" width="100" />
          <el-table-column prop="email" label="Email" />
          <el-table-column prop="name" label="Name" />
          <el-table-column prop="master_brand_name" label="Master Brand" />
          <el-table-column label="Brand Status">
            <template #default="scope">
              <span style="margin-right: 10px;">{{ generateBrandStatus(scope.row.master_brand_status) }}</span>
              <el-popconfirm
                v-if="scope.row.master_brand_status == 'pending'"
                title="Confirm that this customer has the brand?"
                @confirm="confirmBrand(scope.row)"
              >
                <template #reference>
                  <el-button size="medium" type="text" class="el-btn-blue">
                    Confirm
                  </el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
          <!-- Last updatedd -->
          <el-table-column label="Created at">
            <template #default="scope">
              <span>{{ generateTime(scope.row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operate">
            <template #default="scope">
              <div class="table-operate">
                <!-- <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="editUser(scope.row)">Edit</el-button>
                </div> -->
                <!-- <div class="operate-item">
                  <el-popconfirm
                    title="Confirm to import ATK products?"
                    @confirm="importProducts(scope.row)"
                  >
                    <template #reference>
                      <el-button size="small" type="text" class="el-btn-blue">Import</el-button>
                    </template>
                  </el-popconfirm>
                </div> -->
                <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="editFeatures(scope.row)">Edit Features</el-button>
                </div>
                <div class="operate-item">
                  <el-button size="small" type="text" class="el-btn-blue" @click="resetPassword(scope.row)">Reset Password</el-button>
                </div>
                <div class="operate-item">
                  <el-popconfirm
                    title="Confirm to delete this record?"
                    @confirm="deleteUser(scope.row)"
                  >
                    <template #reference>
                      <el-button size="small" type="text" class="el-btn-blue">Delete</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="common-pagination" background layout="prev, pager, next"
          :current-page="pageNum" :page-size="pageSize" :total="totalNum"
          @current-change="changeCurrentPage"
        />
      </div>
    </div>
    <ModalUser
      v-bind:flagVisible="flagVisible.modalUser" v-on:closeModal="flagVisible.modalUser = false"
      v-bind:actionItem="actionItems.user" v-on:reloadData="reloadData"
    />
    <ModalUserPassword
      v-bind:flagVisible="flagVisible.modalUserPassword" v-on:closeModal="flagVisible.modalUserPassword = false"
      v-bind:actionItem="actionItems.userPassword"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import ModalUser from './modals/User.vue'
import ModalUserPassword from './modals/UserPassword.vue'
export default {
  name: 'AdminCustomers',
  components: {
    ModalUser,
    ModalUserPassword
  },
  data () {
    const filter = reactive({
      name: '',
      email: '',
      brandStatus: ''
    })
    const flagLoading = reactive({
      getUsers: false
    })
    const flagVisible = reactive({
      modalUser: false,
      modalUserPassword: false
    })
    const actionItems = reactive({
      user: {
        _id: '',
        name: '',
        email: '',
        password: '',
        password_confirm: '',
        master_brand_id: '',
        role_id: ''
      },
      userPassword: {}
    })
    return {
      users: [],
      roles: [],
      roleCustomerId: '',
      pageNum: 1,
      pageSize: 20,
      totalNum: 0,
      filter,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: async function () {
    await this.getRoles()
    this.getUsers()
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      currentRole: 'currentRole'
    })
  },
  watch: {
  },
  methods: {
    getRoles: async function () {
      const url = '/api/v1/atk_player/admin/roles?page_num=1&page_size=100&is_deleted=false'
      const that = this
      await this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.roles = res.data.list
          const roleCustomerIndex = _.findIndex(res.data.list, { name: 'customer' })
          if (roleCustomerIndex >= 0) {
            that.roleCustomerId = res.data.list[roleCustomerIndex]._id
            that.actionItems.user.role_id = that.roleCustomerId
          }
        }
      }).catch(function (err) {
        console.error('getRoles', err)
      })
    },
    getUsers: function () {
      this.flagLoading.getUsers = true
      const { pageNum, pageSize, filter, roleCustomerId } = this
      let url = `/api/v1/atk_player/admin/users?page_num=${pageNum}&page_size=${pageSize}`
      url += `&role_id=${roleCustomerId}&is_deleted=false`
      if (filter.name) url += `&name=${encodeURIComponent(filter.name)}`
      if (filter.email) url += `&email=${encodeURIComponent(filter.email)}`
      if (filter.brandStatus) url += `&master_brand_status=${filter.brandStatus}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.users = res.data.list
          that.totalNum = res.data.total_num
        }
        that.flagLoading.getUsers = false
      }).catch(function (err) {
        console.error('getUsers', err)
        that.flagLoading.getUsers = false
      })
    },
    generateBrandStatus: function (status) {
      let statusStr = ''
      switch (status) {
        case 'pending':
          statusStr = 'Pending'
          break
        case 'active':
          statusStr = 'Active'
          break
      }
      return statusStr
    },
    generateTime: function (time) {
      const tz = moment().utcOffset()
      return moment(time).utcOffset(tz).format('D MMM YYYY HH:mm')
    },
    changeCurrentPage: function (page) {
      this.pageNum = page
      this.getUsers()
    },
    changeFilter: function () {
      this.pageNum = 1
      this.getUsers()
    },
    resetFilter: function () {
      this.filter = { name: '', email: '', brandStatus: '' }
      this.pageNum = 1
      this.getUsers()
    },
    generateIndex: function (index) {
      const { pageNum, pageSize } = this
      return index + 1 + pageSize * (pageNum - 1)
    },
    newUser: function () {
      const actionUser = this.actionItems.user
      if (actionUser._id) {
        this.actionItems.user = {
          _id: '',
          name: '',
          email: '',
          password: '',
          password_confirm: '',
          master_brand_id: '',
          role_id: this.roleCustomerId
        }
      }
      this.flagVisible.modalUser = true
    },
    editUser: function (user) {
      const actionUser = this.actionItems.user
      if (actionUser._id !== user._id) {
        this.actionItems.user = { ...user }
      }
      this.flagVisible.modalUser = true
    },
    editFeatures: function (user) {
      this.$router.push({
        path: `/${this.currentRole}/customers/${user._id}/edit`
      })
    },
    resetPassword: function (user) {
      const actionUser = this.actionItems.userPassword
      if (actionUser._id !== user._id) {
        this.actionItems.userPassword = { ...user }
      }
      this.flagVisible.modalUserPassword = true
    },
    reloadData: function () {
      this.actionItems.user = {
        _id: '',
        name: '',
        email: '',
        password: '',
        password_confirm: '',
        master_brand_id: '',
        role_id: this.roleCustomerId
      }
      this.getUsers()
    },
    deleteUser: function (user) {
      const url = `/api/v1/atk_player/admin/users/${user._id}`
      const that = this
      this.$service.delete(url).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Delete success' })
          that.getUsers()
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('deleteUser', err)
      })
    },
    confirmBrand: function (user) {
      const url = `/api/v1/atk_player/admin/users/${user._id}`
      const that = this
      this.$service.put(url, { master_brand_status: 'active' }).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Confirm success' })
          that.getUsers()
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('confirmBrand', err)
      })
    },
    importProducts: function (user) {
      const url = '/api/v1/atk_player/admin/products/import'
      const that = this
      if (!user.master_brand_id) {
        that.$message({ type: 'warning', message: "This customer doesn't have a Master Brand" })
        return
      }
      const params = { customer_id: user._id, brand_id: user.master_brand_id }
      this.$service.post(url, params).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Import success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
      }).catch(function (err) {
        console.error('importProducts', err)
        that.$message({ type: 'error', message: err.msg || 'Unknown error' })
      })
    }
  }
}
</script>
